// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}", ""]);
// Exports
module.exports = exports;
